import { FC } from 'react';
import styled from 'styled-components';

const GroupElement = styled.div`
  grid-area: ${(props: any) => props.name};
  display: flex;
  padding: ${(props: any) => props.padding || 0}px;
  flex-flow: ${(props: any) => (props.direction === 'vertical' ? 'column' : 'row')};
  align-items: ${(props: any) =>
    props.direction === 'vertical' ? (props.align === 'center' ? 'center' : 'flex-start') : 'center'};
  justify-content: ${(props: any) =>
    props.align === 'center'
      ? 'center'
      : props.align === 'right'
      ? 'flex-end'
      : props.align === 'space-around'
      ? 'space-around'
      : 'flex-start'};

  flex: ${(props: any) => (props.grow ? '1' : 'none')};
  border-radius: 5px;
  border: ${(props: any) => (props.variation === 'danger' ? '4px solid #FF7F00' : 'none')};

  & > * {
    margin-right: ${(props: any) => (props.gap && props.direction !== 'vertical' ? props.gap : 5)}px;
    margin-bottom: ${(props: any) => (props.gap && props.direction === 'vertical' ? props.gap : 0)}px;
  }

  &&& > *:last-child {
    margin-right: 0px;
    margin-bottom: 0px;
  }
` as any;

export type GroupVariation = 'normal' | 'danger';
export type GroupAlignment = 'left' | 'center' | 'right' | 'space-around';
export type GroupDirection = 'horizontal' | 'vertical';

export interface IProps {
  /** 'normal' (default) or 'danger'. (Experimental) */
  variation?: GroupVariation;
  /** The name of the group. */
  name?: string;
  /** 'left' (default) or 'center'. (Experimental) */
  align?: GroupAlignment;
  /** 'horizontal' (default) or 'vertical'. */
  direction?: GroupDirection;
  /** gap in pixels (based on direction). (Experimental) */
  gap?: number;
  /** padding to apply around group (defaults to 0). (Experimental) */
  padding?: number;
  /** Whether group should fill remaining space or not. (Defaults to false) */
  grow?: boolean;
}

export const Group: FC<IProps> = props => {
  return (
    <GroupElement data-testid="GroupElement" {...props}>
      {props.children}
    </GroupElement>
  );
};
